import { render } from "./CoBrandNova.vue?vue&type=template&id=d8949e98&scoped=true"
import script from "./CoBrandNova.vue?vue&type=script&lang=js"
export * from "./CoBrandNova.vue?vue&type=script&lang=js"

import "./CoBrandNova.vue?vue&type=style&index=0&id=d8949e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8949e98"]])

export default __exports__